import { render, staticRenderFns } from "./matrices-control.vue?vue&type=template&id=677f100c"
import script from "./matrices-control.vue?vue&type=script&lang=js"
export * from "./matrices-control.vue?vue&type=script&lang=js"
import style0 from "./matrices-control.vue?vue&type=style&index=0&id=677f100c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports